(() => {
  const initFinder = (root) => {
    if (!root || root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';

    const steps = [...root.querySelectorAll('[data-step]')];
    const results = root.querySelector('[data-finder-results]');
    const panels = [...root.querySelectorAll('[data-result-key]')];
    const progress = [...root.querySelectorAll('[data-progress]')];
    const resultsHeading = root.querySelector('[data-results-heading]');
    let age = '';

    const emit = (action, value) => {
      root.dispatchEvent(new CustomEvent('ics:gear-finder', {
        bubbles: true,
        detail: { action, value }
      }));
    };

    const resetPressed = () => {
      root.querySelectorAll('[aria-pressed]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
    };

    const updateProgress = (stage) => {
      progress.forEach((el, index) => {
        el.classList.toggle('is-active', index < stage);
      });
    };

    const focusFirstQuestion = (container) => {
      const target = container?.querySelector('[tabindex="-1"]');
      if (target) requestAnimationFrame(() => target.focus({ preventScroll: true }));
    };

    const showStep = (name) => {
      steps.forEach((step) => {
        step.hidden = step.dataset.step !== name;
      });
      if (results) results.hidden = true;
      panels.forEach((panel) => { panel.hidden = true; });

      const stage = name === 'gear' ? 1 : name === 'age' ? 2 : 3;
      updateProgress(stage);
      const active = root.querySelector(`[data-step="${name}"]`);
      focusFirstQuestion(active);
    };

    const showResults = (key) => {
      steps.forEach((step) => { step.hidden = true; });
      panels.forEach((panel) => { panel.hidden = panel.dataset.resultKey !== key; });
      if (results) results.hidden = false;
      updateProgress(3);
      if (resultsHeading) requestAnimationFrame(() => resultsHeading.focus({ preventScroll: true }));
      emit('result', key);
    };

    root.addEventListener('click', (event) => {
      const gearButton = event.target.closest('[data-gear-choice]');
      if (gearButton && root.contains(gearButton)) {
        root.querySelectorAll('[data-gear-choice]').forEach((button) => {
          button.setAttribute('aria-pressed', button === gearButton ? 'true' : 'false');
        });
        const gear = gearButton.dataset.gearChoice;
        emit('gear', gear);
        if (gear === 'bat') {
          showStep('age');
        } else {
          showResults(gear);
        }
        return;
      }

      const ageButton = event.target.closest('[data-age-choice]');
      if (ageButton && root.contains(ageButton)) {
        root.querySelectorAll('[data-age-choice]').forEach((button) => {
          button.setAttribute('aria-pressed', button === ageButton ? 'true' : 'false');
        });
        age = ageButton.dataset.ageChoice;
        emit('age', age);
        showStep('budget');
        return;
      }

      const budgetButton = event.target.closest('[data-budget-choice]');
      if (budgetButton && root.contains(budgetButton)) {
        root.querySelectorAll('[data-budget-choice]').forEach((button) => {
          button.setAttribute('aria-pressed', button === budgetButton ? 'true' : 'false');
        });
        const budget = budgetButton.dataset.budgetChoice;
        emit('budget', budget);
        if (age) showResults(`bat-${age}-${budget}`);
        return;
      }

      const backButton = event.target.closest('[data-back]');
      if (backButton && root.contains(backButton)) {
        showStep(backButton.dataset.back);
        return;
      }

      const restart = event.target.closest('[data-finder-restart]');
      if (restart && root.contains(restart)) {
        age = '';
        resetPressed();
        showStep('gear');
        emit('restart', 'gear');
      }
    });

    showStep('gear');
  };

  const initAll = () => document.querySelectorAll('[data-gear-finder]').forEach(initFinder);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-gear-finder]').forEach(initFinder);
  });
})();